<section class="py-4">

  <div class="row mx-2">

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="unidade">Unidade</label>
      <input [formControl]="form.controls.unidade" id="unidade" type="number" class="form-control">
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="rsl">Razão social</label>
      <input [formControl]="form.controls.razaoSocial" id="rsl" type="text" class="form-control">
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="entrada">Entrada</label>
      <input [formControl]="form.controls.entrada" id="entrada" type="text" class="form-control">
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="prod">Produto</label>
      <input [formControl]="form.controls.produto" id="prod" type="text" class="form-control">
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="">Data inicio</label>
      <input (focus)="dinicio.open()" name="dataInicio" (ngModelChange)="setDataInicio($event)"
        [(ngModel)]="pesquisaDataInicio" ngbDatepicker #dinicio="ngbDatepicker" type="text" class="form-control">
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="">Data termino</label>
      <input (focus)="dfim.open()" name="dataFim" (ngModelChange)="setDataFim($event)" [(ngModel)]="pesquisaDataFim"
        ngbDatepicker #dfim="ngbDatepicker" type="text" class="form-control">
    </div>

  </div>


  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="table-responsive">

      <p-table #dt [columns]="cols"
        styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
        [value]="listaResultado" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
        [(selection)]="object" [first]="first">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.idCarsys"
              (tableOrderChange)="changeOrder()">Unidade</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.razaoSocial"
              (tableOrderChange)="changeOrder()" class="text-center">Razão social</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.placa"
              (tableOrderChange)="changeOrder()" class="text-center">Placa</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.chassi"
              (tableOrderChange)="changeOrder()" class="text-center">Chassi</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.dataConsulta"
              (tableOrderChange)="changeOrder()" class="text-center">Data</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.produto"
              (tableOrderChange)="changeOrder()" class="text-center">Produto</th>
            <th style="width: 5%;" class="text-center px-0" *ngIf="usuario.permissoes.administrador">Ações</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData">

            <td>{{rowData.idCarsys}}</td>
            <td>{{rowData.razaoSocial}}</td>
            <td>{{rowData.placaPrint}}</td>
            <td>{{rowData.chassi}}</td>
            <td>{{rowData.dataConsulta | date: 'dd/MM/yyyy'}}</td>
            <td>{{rowData.produto}}</td>
            <td class="py-1" *ngIf="usuario.permissoes.administrador">
              <div class="d-flex align-items-center justify-content-center">
                <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="excluirLaudo(rowData)" class="btn btn-sm btn-danger btn-icon">
                    <i class="mdi mdi-close"></i>
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-columns>
          <div class="card-footer bg-white row justify-content-between minPage630 ">

            <div class="pb-2 pb-sm-0">
              <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total"
                [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
              </ngb-pagination>
            </div>
            <div class="pb-2 pb-sm-0">
              <div class="btn-group" role="group">
                <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                  <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                    class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom">
                  </button>
                </span>
                <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}"
                  type="button" class="btn btn-outline-primary">10</button>
                <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}"
                  type="button" class="btn btn-outline-primary">25</button>
                <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}"
                  type="button" class="btn btn-outline-primary">50</button>
                <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}"
                  type="button" class="btn btn-outline-primary">100</button>
              </div>
            </div>


          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              Nenhum registro foi encontrado
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>

  </div>

</section>